import { emit } from '@rsql/emitter';
import { parse } from '@rsql/parser';
import {
  isComparisonNode,
  isLogicNode,
  getSelector,
  getValue,
} from '@rsql/ast';

import builder from '@rsql/builder';
import velarisFilterLanguage, {
  VFL_COMPARATORS_FILTER_COMPARATOR_LOOKUP,
} from './velarisFilterLanguage';

export const convertFilterToVfl = (filters) => {
  if (!filters || filters.length < 1 || Object.keys(filters).length === 0) {
    return null;
  }
  const expressions = filters.map((filterNode) => {
    const { attribute, filter, value } = filterNode;
    const { name, definitionType, dataType } = attribute;
    const type = definitionType || '';
    const identifier = `${dataType}:${type}:${name}`;
    const vflExpressionBuilder = velarisFilterLanguage[filter];
    return vflExpressionBuilder(identifier, value);
  });
  const finalExpression = builder.and(...expressions);
  return emit(finalExpression);
};
const convertComparisonToFilter = (comparisonNode) => {
  const selector = getSelector(comparisonNode);
  const { operator } = comparisonNode;
  const value = getValue(comparisonNode);
  const identifierParts = selector.split(':');
  const attribute = {
    name:
      identifierParts.length > 3
        ? identifierParts.slice(2).join(':')
        : identifierParts[2],
    definitionType: identifierParts[1] === '' ? undefined : identifierParts[1],
    dataType: identifierParts[0],
  };
  const filterNode = {
    attribute,
    filter: VFL_COMPARATORS_FILTER_COMPARATOR_LOOKUP[operator],
    value,
  };

  return filterNode;
};

function convertExpressionToFilter(expression) {
  if (isComparisonNode(expression)) {
    return [convertComparisonToFilter(expression)];
  }
  if (isLogicNode(expression)) {
    // eslint-disable-next-line no-use-before-define
    return convertLogicToFilter(expression);
  }
  throw new Error('Cannot parse filter');
}

function convertLogicToFilter(logicNode) {
  const leftNode = convertExpressionToFilter(logicNode.left);
  const rightNode = convertExpressionToFilter(logicNode.right);
  return [...leftNode, ...rightNode];
}
export const convertVflToFilter = (filterString) => {
  const filters = [];
  if (filterString === null || filterString.trim() === '') {
    return filters;
  }
  const expression = parse(filterString);
  filters.push(...convertExpressionToFilter(expression));
  return filters;
};
